import { render, staticRenderFns } from "./IntelligentAssistant.vue?vue&type=template&id=594d3680&scoped=true&"
import script from "./IntelligentAssistant.vue?vue&type=script&lang=js&"
export * from "./IntelligentAssistant.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentAssistant.vue?vue&type=style&index=0&id=594d3680&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d3680",
  null
  
)

export default component.exports